import { Divider, Form, Table, Input, DatePicker, Select } from 'antd';
import { useTranslation } from 'react-i18next';

import { StepsButton } from './BtnSave';
import React from 'react';
import IconEmpty from './iconEmpty';
import init from './init.json';
import { nameCondition, nameConditionRisk } from './Step5';
import { useDpiaContext } from '../dpia.context';
import { useEffect } from 'react';

const { TextArea } = Input;

export default function Step7(props) {
    const { setStep7, setStepNo } = useDpiaContext();
    const { t } = useTranslation(['translation', 'dpia']);

    const dpiaMitigatingMeasuresList = Form.useWatch(
        'dpiaMitigatingMeasuresList',
        props.form6
    );
    const opinionDpo = Form.useWatch('opinionDpo', props.form);
    const opinionConsult = Form.useWatch('opinionConsult', props.form);

    const onNextStep = () => {
        props.nextStep();
    };

    const onPreviousStep = () => {
        props.previousStep();
    };

    const options = [
        {
            value: true,
            label: t('Agree'),
        },
        {
            value: false,
            label: t('Disagree'),
        },
    ];

    const columns = [
        {
            title: t('Measures to be implemented'),
            dataIndex: 'dpiaMitigatingMeasuresOrganizeName',
            key: 'dpiaMitigatingMeasuresOrganizeName',
        },
        {
            title: t('Consequences of risk'),
            dataIndex: 'effectOnRisk',
            key: 'effectOnRisk',
            render: (text) => nameCondition(text, t),
        },
        {
            title: t('Remaining risk'),
            dataIndex: 'remainingRisk',
            key: 'remainingRisk',
            render: (text) => nameConditionRisk(text, t),
        },
        {
            title: t('Consideration result'),
            dataIndex: 'considerationResult',
            key: 'considerationResult',
            render: (text) => nameCondition(text, t),
        },
    ];

    useEffect(() => {
        setStepNo(7)
    }, []); 

    return (
        <div hidden={!props?.isActive}>
            <div className="flex">
                <div>
                    <h1 className="text-2xl font-semibold text-purple">
                        {t('step 7')}: {t('Documentation and planning')}
                    </h1>
                    <p className="text-sm text-gray-PHX m-0">
                        {t('DPIA step 7 description')}
                    </p>
                </div>
            </div>
            <Divider />
            <p className="text-xl font-semibold text-gray-dark">
                {t('Recording details and planning')}
            </p>
            <h5 className="text-base font-semibold text-gray-dark">
                {t('Summarize the proposed measures for implementation')}
            </h5>
            <Table
                className="inbox_table"
                rowKey={(record, i) => i}
                dataSource={dpiaMitigatingMeasuresList || []}
                columns={columns}
                pagination={false}
                locale={{
                    emptyText: (
                        <div className="text-center m-auto text-black">
                            <IconEmpty />
                            <div>
                                {t('No information found')}
                                <br />
                                {t('Please enter information in step', {
                                    step: '6.2',
                                })}
                            </div>
                        </div>
                    ),
                }}
            />
            <p className="text-purple font-semibold text-sm my-4">
                {t('Document Description')}
            </p>
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                initialValues={init.planning}
                layout="vertical"
                name="planning"
                form={props?.form}
            >
                <Form.Item
                    name="projectName"
                    className="mt-2 mb-4"
                    label={
                        <h5 className="text-base text-gray-dark text-left font-semibold m-0">
                            {t('Project Name')}
                        </h5>
                    }
                >
                    <Input
                        style={{ backgroundColor: '#f5f6ff' }}
                        className="rounded-lg"
                        size="large"
                        placeholder={t('Identify the project name')}
                    />
                </Form.Item>
                <h5 className="text-base text-gray-dark text-left font-semibold m-0 pt-2">
                    {t('Date of implementation')}
                </h5>
                <div className="grid gap-x-4 grid-cols-2">
                    <Form.Item
                        name="startDate"
                        className="mt-2 w-full"
                        label={false}
                    >
                        <DatePicker
                            style={{ width: '100%' }}
                            size="large"
                            format="DD/MM/YYYY"
                            placeholder={t('Start')}
                        />
                    </Form.Item>
                    <Form.Item
                        name="endDate"
                        className="mt-2 w-full"
                        label={false}
                        rules={[
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    const startDate =
                                        getFieldValue('startDate');
                                    if (
                                        getFieldValue('startDate') &&
                                        value &&
                                        value.isBefore(startDate)
                                    ) {
                                        setStep7(false);
                                        return Promise.reject(
                                            'End date cannot be before the start date'
                                        );
                                    }
                                    setStep7(true);
                                    return Promise.resolve();
                                },
                            }),
                        ]}
                    >
                        <DatePicker
                            style={{ width: '100%' }}
                            size="large"
                            format="DD/MM/YYYY"
                            placeholder={t('End')}
                        />
                    </Form.Item>
                </div>
                <h5 className="text-base text-gray-dark text-left font-semibold m-0 pt-2">
                    {t('Responsible owner')}
                </h5>
                <Form.Item label={false} name="projectOwner">
                    <TextArea
                        rows={4}
                        placeholder={t(
                            'Identify the name of the responsible owner'
                        )}
                        maxLength={250}
                        showCount
                    />
                </Form.Item>
                <h5 className="text-base text-gray-dark text-left font-semibold m-0 pt-2">
                    {t('Remaining Risk')}
                </h5>
                <Form.Item label={false} name="dpiaRemainingRisk">
                    <TextArea
                        placeholder={t('Identify remaining risks')}
                        rows={4}
                        maxLength={500}
                        showCount
                    />
                </Form.Item>
                <Divider />
                <h5 className="text-base text-gray-dark text-left font-semibold m-0">
                    {t('Opinion of the Data Protection Officer')}
                </h5>
                <Form.Item
                    name="opinionDpo"
                    className="mt-2 mb-4"
                    label={
                        <h5 className="text-sm text-gray-dark text-left font-semibold m-0">
                            {t('Opinion')}
                        </h5>
                    }
                >
                    <Select
                        placeholder={t('Select option')}
                        size="large"
                        allowClear
                        style={{ width: 330 }}
                        options={options}
                    />
                </Form.Item>
                {opinionDpo === false && (
                    <Form.Item
                        name="dpoReason"
                        label={t('Reasons for disagreement')}
                    >
                        <TextArea
                            rows={4}
                            placeholder={t(
                                'Enter your reason for disagreement'
                            )}
                            maxLength={250}
                            showCount
                        />
                    </Form.Item>
                )}

                <h5 className="text-base text-gray-dark text-left font-semibold m-0">
                    {t('Results from consultations and feedback')}
                </h5>
                <Form.Item
                    name="opinionConsult"
                    className="mt-2 mb-4"
                    label={
                        <h5 className="text-sm text-gray-dark text-left font-semibold m-0">
                            {t('Opinion')}
                        </h5>
                    }
                >
                    <Select
                        placeholder={t('Select option')}
                        size="large"
                        allowClear
                        style={{ width: 330 }}
                        options={options}
                    />
                </Form.Item>
                {opinionConsult === false && (
                    <Form.Item
                        name="consultReason"
                        label={t('Reasons for disagreement')}
                    >
                        <TextArea
                            rows={4}
                            placeholder={t(
                                'Enter your reason for disagreement'
                            )}
                            maxLength={250}
                            showCount
                        />
                    </Form.Item>
                )}
            </Form>
            <Divider />
            <StepsButton previous={onPreviousStep} next={onNextStep} />
        </div>
    );
}
